import methods from '../methods'

const API_URL = '/api'

const getStudyReason = () => methods.GET_API(`${API_URL}/study-reasons`)

export default {
  getStudyReason
}
